module.exports = __webpack_public_path__ + "static/media/arunachal_pradesh.fc4015c8.png";